<div class="loading_content" [ngClass]="{'error': failed}">
	<span class="logo">
		<img src="/assets/iconRefresh.svg" alt="">
	</span>
	<div class="text" *ngIf="!failed">
		<h2>Fetching units</h2>
		<p>Please wait while we retrieve a list of available storage units.</p>
	</div>
	<div class="text" *ngIf="failed">
		<h2>Could not fetch available units</h2>
		<p>We could not retrieve a list of available units at this time. <a (click)="reloadUnits()">Click here</a> to try again.</p>
		<p>If that does not work, please contact one of our consultants on <a href="tel:0861736827">0861736827</a> for assistance.</p>
	</div>
</div>